import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DispatchManagerComponent } from './dispatch-manager.component';
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatButtonModule, MatRippleModule, MatSidenavModule, MatToolbarModule } from "@angular/material";
import { RouterModule } from "@angular/router";
import { MaterialModule } from "../../material.module";
import { TbWaterfallModule } from "../../tb/tb-waterfall/tb-waterfall.module";

@NgModule({
  declarations: [DispatchManagerComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    MatRippleModule,
    MatButtonModule,
    MatToolbarModule,
    MatSidenavModule,
    TbWaterfallModule,
    RouterModule
  ],
  exports: [DispatchManagerComponent]
})
export class DispatchManagerModule { }
